module.exports = __webpack_public_path__ + "europa-5_signature.jpg?63f70b9a66a04419201f669bef2c9ca3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_signature.jpg
// module id = 393
// module chunks = 0